import { useEffect } from "react";
import Table from "../../../component/table/Table";
import { fetchCantines } from "../../../features/cantine/cantineThunk";
// import tableData from "../../../utils/strucuture/cantineData.json";
import { useDispatch, useSelector } from "react-redux";
import { selectCantines, selectError, selectIsLoading } from "../../../features/cantine/cantineSlice";
import { fetchCompanies } from "../../../features/company/companyThunk";

const Cantine = () => {
  const columns = [
    { field: "nomeCantina", headerName: "Nome Cantina", width: 965 },
    { field: "tipo", headerName: "Tipo di produzione", width: 140 },
    { field: "civico", headerName: "Citta", width: 105 },
    { field: "via", headerName: "Via", width: 160 },
    { field: "pr", headerName: "PR", width: 80 },
    { field: "cap", headerName: "Cap", width: 75 },
    { field: "regione", headerName: "Regione", width: 160 },
    { field: "azioni", headerName: "Azioni", width: 60, sortable: false },
  ];

  useEffect(() => {
    dispatch(fetchCompanies())
  },[])

  // Cantine selectors
  const cantines = useSelector(selectCantines) || [];
  const cantineLoading = useSelector(selectIsLoading);
  const cantineError = useSelector(selectError);
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);

  const dispatch = useDispatch();

  useEffect(() => {
   
      dispatch(fetchCantines());
    
  }, [dispatch,selectSelectedCompany]);

  // Format cantines data for the table
  const formattedCantines = cantines.map((item) => ({

    id: item?.id || "N/A",
    nomeCantina: item?.name || "N/A",
    // cfPiva: item?.tipo_di_produzione || "N/A",
    tipo: item?.tipo_di_produzione || "N/A", // :white_check_mark: fixed typo
    via: item?.address || "N/A",
    civico: item?.city || "N/A",
    cap: item?.zip_code || "N/A",
    pr: item?.state || "N/A",
    regione: item?.region || "N/A",
  }));

  console.log("Formatted Data for Table:", formattedCantines);

  return (
    <div className="pageTemplate">
      {cantineLoading && <p>Loading...</p>}
      {console.log(cantineError)}
      {/* {cantineError && <p style={{ color: "red" }}>Error: {cantineError.message}</p>} */}

      {/* Pass formattedCantines instead of cantines */}
      <Table
        data={formattedCantines?.length ? formattedCantines : []}
        columns={columns}
        navData={"cantine"}
        deleteFunctions={"deleteCantine"}
      />
    </div>
  );
};

export default Cantine;
